import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, getcountries, getpayment, getcurrencyType, getseriesType} from '../../../services/event/refundForms/refundServices';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';
const subDomain = localStorage.getItem('sub_domain') || '';

const Refund = () => {
  const [dataList, setDataList] = useState([]);
  const [names, setNames] = useState([]);
  const [form, setForm] = useState({
    id: '',
    pr_id : '',
    series : '',
    name : '',
    email : '',
    countries : '',
    phone_no : '',
    currency : '',
    actual_amount : '',
    refund_amount : '',
    remaining_amount : '',
    paypal_email : '',
    refund_through : '',
    bank_name : '',
    bank_address: '',
    bank_country: '',
    postal_code: '',
    account_number: '',
    swift_code_ifsc_code: '',
    iban_code: '',
    refund_date: '',
    transaction_id: '',
    status: 0,
    sub_domain : subDomain,
    updatedAt : ''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  // Filter States
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
    currencyType: [],
    countries: []
  });
 
  // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [ currency, country] = await Promise.all([
        getcurrencyType(),
        getcountries()
      ]);
 
      setDropdownData({
        currencyType: currency,
        countries: country
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
 
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({sub_domain: subDomain });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);
  const fetchPaymentData = useCallback(async () => {
    try {
      const data = await getpayment({sub_domain: subDomain });
      console.log('data', data);
      setNames(data); // Set payment data
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  const fetchseriesType = useCallback(async () => {
        try {
          const data = await getseriesType({ sub_domain: subDomain });
          if (data && data.length > 0) {
            const seriesInfo = data[0]; // Assuming you're using the first item
            setForm(prev => ({
              ...prev,
              series: seriesInfo.series || ''       
            }));
            console.log("Setting series:", seriesInfo.series);
  
          }
        } catch (error) {
          console.error('Failed to fetch series info:', error);
        }
      }, []);
  

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      await fetchPaymentData();
      await fetchseriesType(); 
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
    fetchDataAsync();
 
  }, [fetchData, fetchDropdownData, fetchPaymentData, fetchseriesType]);
  
  useEffect(() => {
    const actual = parseFloat(form.actual_amount) || 0;
    const refund = parseFloat(form.refund_amount) || 0;
    const remaining = actual - refund;
  
    setForm((prevForm) => ({
      ...prevForm,
      remaining_amount: remaining.toFixed(2),
    }));
  }, [form.actual_amount, form.refund_amount]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Special logic when refund_through changes
    if (name === 'refund_through') {
      setForm((prev) => ({
        ...prev,
        [name]: value,
        paypal_email: value === 'paypal' ? prev.paypal_email : '', // keep PayPal email only if refund_through is paypal
        bank_name: value !== 'paypal' ? prev.bank_name : '',
        bank_address: value !== 'paypal' ? prev.bank_address : '',
        bank_country: value !== 'paypal' ? prev.bank_country : '',
        postal_code: value !== 'paypal' ? prev.postal_code : '',
        account_number: value !== 'paypal' ? prev.account_number : '',
        swift_code_ifsc_code: value !== 'paypal' ? prev.swift_code_ifsc_code : '',
        iban_code: value !== 'paypal' ? prev.iban_code : '',
      }));
      return;
    }
  
    // Generic change for other fields
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));

  };

  const validateForm = () => {
    const newErrors = {};
  
    if (!form.pr_id) newErrors.pr_id = 'Please select a name';
    if (!form.refund_amount) newErrors.refund_amount = 'Refund amount is required';
    if (!form.phone_no) newErrors.phone_no = 'Phone number is required';
    if (!form.refund_through) newErrors.refund_through = 'Please select refund method';
  
    if (form.refund_through === 'paypal') {
      if (!form.paypal_email) newErrors.paypal_email = 'PayPal email is required';
    } else {
      if (!form.bank_name) newErrors.bank_name = 'Bank name is required';
      if (!form.bank_address) newErrors.bank_address = 'Bank address is required';
      if (!form.bank_country) newErrors.bank_country = 'Bank country is required';
      if (!form.postal_code) newErrors.postal_code = 'Postal code is required';
      if (!form.account_number) newErrors.account_number = 'Account number is required';
      if (!form.swift_code_ifsc_code) newErrors.swift_code_ifsc_code = 'SWIFT or IFSC code is required';
      if (!form.iban_code) newErrors.iban_code = 'IBAN code is required';
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      console.log("Form data to be submitted:", form);
  
      if (modalType === 'add') {
        await addData(form);
      } else if (modalType === 'edit') {
        await updateData({ ...form, status: 0 }); // ✅ Set pdf_status to 0 on update
        
      }
  
      fetchData();
      setShowModal(false);
      // ✅ Show success alert with auto-close
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Refund ${modalType === 'add' ? 'added' : 'updated'} successfully!`,
        timer: 2000, // 2 seconds
        showConfirmButton: false,
      });

    } catch (error) {
      console.error('Error during form submission:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while submitting the form!',
      });
    }
  };
  
  const openModal = async (type, data = {
      id: '',
      pr_id : '',
      series : '',
      name : '',
      email : '',
      countries : '',
      phone_no : '',
      currency : '',
      actual_amount : '',
      refund_amount : '',
      remaining_amount : '',
      paypal_email : '',
      refund_through : '',
      bank_name : '',
      bank_address: '',
      bank_country: '',
      postal_code: '',
      account_number: '',
      swift_code_ifsc_code: '',
      iban_code: '',
      refund_date: null,
      transaction_id: '',
      sub_domain : '',
      updatedAt : ''
    }) => {
      setErrors({}); // ✅ Clear previous errors
      setModalType(type);
      setForm(data);
    
      if (type === 'add' || type === 'edit') {
         try {
            const seriesData = await getseriesType({ sub_domain: subDomain });
              if (seriesData?.length > 0) {
                data.series = seriesData[0].series;
              }           
          } catch (error) {
            console.error("Error fetching receipt ID:", error);
          }
        setShowModal(true); // Show the Add/Edit Modal
      } else if (type === 'view') {
        setShowViewModal(true); // Show the View Modal
      }
    };
 
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleNameChange = (paymentId) => {
    const selectedPerson = names.find((person) => person.payment_id === paymentId);
  
    if (selectedPerson) {
      setForm((prevForm) => ({
        ...prevForm,
        name: selectedPerson.billing_full_name,
        pr_id: selectedPerson.payment_id,
        email: selectedPerson.billing_email,
        countries: selectedPerson.billing_countries,
        currency: selectedPerson.currency_type,
        actual_amount: selectedPerson.reg_amount,
        series: selectedPerson.series,
        sub_domain: selectedPerson.sub_domain,
      }));
    }
  };

  const getCurrencySymbol = (currencyCode) => {
  switch (currencyCode?.toUpperCase()) {
    case 'USD': return '$';
    case 'EUR': return '€';
    case 'INR': return '₹';
    case 'GBP': return '£';
    case 'RUB': return '₽';
    case 'THB': return '฿';
    default: return currencyCode || '';
  }
};

  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };

  const getRefundThroughLabel = (value) => {
  switch (value) {
    case 'bank-mercury': return 'Bank (Mercury)';
    case 'bank-hdfc': return 'Bank (HDFC)';
    case 'paypal': return 'Paypal';
    default: return value;
  }
};

  
  // Memoized filtered data based on search query
  // const filteredData = useMemo(() => {
  //   return dataList.filter(
  //     (data) =>
  //       data.name.toLowerCase().includes(searchText.toLowerCase()) ||
  //       data.refund_amount.toString().includes(searchText.toLowerCase()) ||
  //       data.countries.toLowerCase().includes(searchText.toLowerCase()) || 
  //       data.currency.toLowerCase().includes(searchText.toLowerCase())
  //   ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  // }, [dataList, searchText]);

  const filteredData = useMemo(() => {
    const startDateObj = startDate ? new Date(startDate) : null;
    const endDateObj = endDate ? new Date(endDate) : null;
  
    return dataList
      .filter((data) => {
        // Text search (case insensitive)
        const matchesText =
          data.name.toLowerCase().includes(searchText.toLowerCase()) ||
          data.refund_amount.toString().includes(searchText.toLowerCase()) ||
          data.countries.toLowerCase().includes(searchText.toLowerCase()) || 
          data.currency.toLowerCase().includes(searchText.toLowerCase());
  
        // Convert abstract_date to Date for comparison
        const date = data.updatedAt ? new Date(data.updatedAt) : null;

        // Date range filtering
        const inRange = (startDateObj && endDateObj)
          ? date >= startDateObj && date <= endDateObj
          : true;
  
        // Country filtering
        const matchCountry = !countryFilter || data.countries === countryFilter;
  
        return matchesText && inRange && matchCountry;
      }).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  }, [dataList, searchText, startDate, endDate, countryFilter]);
 
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '60px',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.countries),
      sortable: true,
    },
    {
      name: 'Currency',
      selector: (row) => row.currency,
      sortable: true,
    },
    {
      name: 'Refund Amount',
      selector: (row) => {
        const currencySymbol = getCurrencySymbol(row.currency);
        return <b className='fs-4'>{currencySymbol} {row.refund_amount}</b>;
      },
      sortable: true,
    },
    {
      name: 'Refund Through',
      selector: (row) => getRefundThroughLabel(row.refund_through),
      sortable: true
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
    <Button variant="primary" size="sm" onClick={() => openModal('view', row)} className="me-2">
    <i className="align-middle far fa-fw fa-eye"></i>
    </Button>

    <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
        </div>
      ),
    },
  ];
 
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
         <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            {/* Dropdown for Filters */}
            <div className="col-md-2">
            <span>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>   
        </div>
        {loading ? (
                <div
                    className="d-flex justify-content-center align-items-center w-100"
                    style={{ minHeight: "300px" }}
                  >
                    <Spinner /> {/* Centered Spinner */}
                  </div>
                          ) :(
                  <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4'>Receipt Generation / Refund Generation Form</p>
            </div>
            <div className="col-4 text-end">
            <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
            </button>
            </div>
          </div>
 
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />
 
          {/* Modal for Add/Edit data */}
          <Modal show={showModal} backdrop="static" className='modal-xl' onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
              <Form.Control type="hidden" name="series" value={form.series} />
              <Form.Control type="hidden" name="sub_domain" value={form.sub_domain} />
              <Form.Control type="hidden" name="remaining_amount" value={form.remaining_amount}/>
  
                <div className='row'>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Select
                    name="pr_id"
                    value={form.pr_id}
                    onChange={(e) => handleNameChange(e.target.value)} // send payment_id
                  >
                    <option value="">-- Select --</option>
                    {names
                    .filter((item) => {
                      // Show all names that haven't been refunded yet,
                      // OR match the currently selected pr_id (for editing)
                      return (
                        !dataList.some((d) => d.pr_id === item.payment_id) ||
                        item.payment_id === form.pr_id
                      );
                    })
                    .map((item) => (
                      <option key={item.payment_id} value={item.payment_id}>
                        {item.billing_full_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Control type="hidden" name="name" value={form.name} readOnly />

                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Payment ID<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="pr_id" value={form.pr_id} onChange={handleChange} readOnly />
                </Form.Group>    
               
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="email" value={form.email} onChange={handleChange} readOnly/>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                    <Form.Label>Country<span className="text-danger">*</span></Form.Label>
                    <Form.Select name="countries" value={form.countries} onChange={handleChange} readOnly>
                      <option value="">Select</option>
                      {dropdownData.countries.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Currency<span className="text-danger">*</span></Form.Label>
                  <Form.Control type="text" name="currency" value={form.currency} onChange={handleChange} readOnly/>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Actual Amount <span className="text-danger">*</span></Form.Label>
                  <Form.Control type="number" name="actual_amount" value={form.actual_amount} onChange={handleChange} readOnly/>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Refund Amount<span className="text-danger">*</span> </Form.Label>
                  <Form.Control type="number" name="refund_amount" value={form.refund_amount} onChange={handleChange} isInvalid={!!errors.refund_amount}/>
                  <Form.Control.Feedback type="invalid">  {errors.refund_amount} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                  <Form.Label>Phone No<span className="text-danger">*</span> </Form.Label>
                  <Form.Control type="number" name="phone_no" value={form.phone_no} onChange={handleChange} isInvalid={!!errors.phone_no}/>
                  <Form.Control.Feedback type="invalid">  {errors.phone_no} </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-3 mb-3">
                <Form.Label>Refund Through <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="refund_through"
                  value={form.refund_through}
                  onChange={handleChange}
                  isInvalid={!!errors.refund_through}
                >
                  <option value="">Select</option>
                  <option value="bank-mercury">Bank (Mercury)</option>
                  <option value="bank-hdfc">Bank (HDFC)</option>
                  <option value="paypal">Paypal</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">  {errors.refund_through} </Form.Control.Feedback>

              </Form.Group>
              <div className="col-md-9 mb-3 d-flex align-items-end">
                			<span><b className="text-primary">Note: </b>Choose the "Bank (HDFC)" option for a refund only if you are located in India.</span> 
              </div>   
                </div>
                
                {form.refund_through === 'paypal' && (
                  <div className="row paypal">
                    <div className="col-md-12">
                      <h5>PayPal Details</h5>
                      <hr />
                    </div>
                    <Form.Group className="col-md-4 mb-3">
                      <Form.Label>PayPal Email/ID </Form.Label>
                      <Form.Control
                        type="email"
                        name="paypal_email"
                        value={form.paypal_email}
                        onChange={handleChange} isInvalid={!!errors.paypal_email}
                      />
                      <Form.Control.Feedback type="invalid">  {errors.paypal_email} </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  )}

                  {form.refund_through !== 'paypal' && (
                    <div className="row bank">
                      <div className="col-md-12">
                        <h5>Bank Details</h5>
                        <hr />
                      </div>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="bank_name">Bank Name <small className="text-danger">*</small></label>
                        <input
                          className="form-control"
                          type="text"
                          name="bank_name"
                          value={form.bank_name}
                          onChange={handleChange}
                          isInvalid={!!errors.bank_name}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.bank_name} </Form.Control.Feedback>
                      </div>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="bank_address">Bank Address <small className="text-danger">*</small></label>
                        <input
                          className="form-control"
                          type="text"
                          name="bank_address"
                          value={form.bank_address}
                          onChange={handleChange}
                          isInvalid={!!errors.bank_address}
                        />
                       <Form.Control.Feedback type="invalid">  {errors.bank_address} </Form.Control.Feedback>
                      </div>

                      <Form.Group className="col-md-4 mb-3">
                        <Form.Label>Bank Country<span className="text-danger">*</span></Form.Label>
                        <Form.Select name="bank_country" value={form.bank_country} onChange={handleChange} isInvalid={!!errors.bank_country}>
                          <option value="">Select</option>
                          {dropdownData.countries.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">  {errors.bank_country} </Form.Control.Feedback>
                      </Form.Group>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="postal_code">Postal Code <small className="text-danger">*</small></label>
                        <input
                          className="form-control"
                          type="text"
                          name="postal_code"
                          value={form.postal_code}
                          onChange={handleChange}
                          isInvalid={!!errors.postal_code}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.postal_code} </Form.Control.Feedback>
                      </div>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="account_number">Account Number <small className="text-danger">*</small></label>
                        <input
                          className="form-control"
                          type="number"
                          name="account_number"
                          value={form.account_number}
                          onChange={handleChange}
                          isInvalid={!!errors.account_number}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.account_number} </Form.Control.Feedback>
                      </div>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="swift_code_ifsc_code">Swift or IFSC Code <small className="text-danger">*</small></label>
                        <input
                          className="form-control"
                          type="text"
                          name="swift_code_ifsc_code"
                          value={form.swift_code_ifsc_code}
                          onChange={handleChange}
                          isInvalid={!!errors.swift_code_ifsc_code}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.swift_code_ifsc_code} </Form.Control.Feedback>
                      </div>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="iban_code">IBAN Code <small className="text-danger">*</small></label>
                        <input
                          className="form-control"
                          type="text"
                          name="iban_code"
                          value={form.iban_code}
                          onChange={handleChange}
                          isInvalid={!!errors.iban_code}
                        />
                        <Form.Control.Feedback type="invalid">  {errors.iban_code} </Form.Control.Feedback>
                      </div>
                    </div>
                  )}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>
 
          {/* View Modal */}
          <Modal className="modal-lg" show={showViewModal} onHide={() => setShowViewModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>View Receipt Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6">
                  <Table striped bordered size="sm">
                    <thead>
                      <tr className="bg-secondary text-light">
                        <th colSpan={2}>User Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Name</td><td>{form.name}</td></tr>
                      <tr><td>Payment ID</td><td>{form.pr_id}</td></tr>
                      <tr><td>Email</td><td>{form.email}</td></tr>
                      <tr><td>Phone No</td><td>{form.phone_no}</td></tr>
                      <tr><td>Country</td><td>{getCountryName(form.countries)}</td></tr>
                      <tr><td>Currency</td><td>{form.currency}</td></tr>
                      <tr><td>Actual Amount</td><td>{form.actual_amount}</td></tr>
                      <tr><td>Refund Amount</td><td>{form.refund_amount}</td></tr>
                      <tr><td>Remaining Amount</td><td>{form.remaining_amount}</td></tr>
                      <tr><td>Refund Through</td><td>{form.refund_through}</td></tr>
                    </tbody>
                  </Table>
                </div>

                <div className="col-md-6">
                  {form.refund_through === 'paypal' ? (
                    <>
                      <Table striped bordered size="sm">
                        <thead>
                          <tr className="bg-secondary text-light">
                            <th colSpan={2}>PayPal Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr><td>PayPal Email/ID</td><td>{form.paypal_email}</td></tr>
                        </tbody>
                      </Table>
                    </>
                  ) : (
                    <>
                      <Table striped bordered size="sm">
                        <thead>
                          <tr className="bg-secondary text-light">
                            <th colSpan={2}>Bank Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr><td>Bank Name</td><td>{form.bank_name}</td></tr>
                          <tr><td>Bank Address</td><td>{form.bank_address}</td></tr>
                          <tr><td>Bank Country</td><td>{getCountryName(form.bank_country)}</td></tr>
                          <tr><td>Postal Code</td><td>{form.postal_code}</td></tr>
                          <tr><td>Account Number</td><td>{form.account_number}</td></tr>
                          <tr><td>Swift/IFSC Code</td><td>{form.swift_code_ifsc_code}</td></tr>
                          <tr><td>IBAN Code</td><td>{form.iban_code}</td></tr>
                        </tbody>
                      </Table>
                    </>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowViewModal(false)}>Close</Button>
            </Modal.Footer>
            </Modal>
        </div>
        <Footer />
      </div>
      )};
    </div>
    </div>
  );
};
 
export default Refund;